/* eslint-disable jsx-a11y/img-redundant-alt */
// @ts-nocheck
import React, { useEffect, useState, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import CancelIcon from "@mui/icons-material/Cancel";
import { toast } from "react-toastify";
import CloudUploadRoundedIcon from "@mui/icons-material/CloudUploadRounded";
import DragIndicatorRoundedIcon from "@mui/icons-material/DragIndicatorRounded";
import { drag_img, dummyimage } from "../../assets/img";

const DragAndDrop = ({
  edit,
  draggableImages,
  setDraggableImages,
  errors,
  setDeletedImages,
}) => {
  const navigate = useNavigate();
  const imgRef = useRef(null);
  // State from Description
  const [popup, setPopup] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  // const [draggableImages, setDraggableImages] = useState([]);
  const [draggedItem, setDraggedItem] = useState(null);

  // Drag and Drop functions

  const draggedItemRef = useRef(null);

  const handleImageDelete = (id) => {
    // propertyImageDelete(id)
    // .unwrap()
    // .then((res) => {
    //     if (res?.status == "success") {
    //         toast.success(res?.message);
    //     }
    // })
    // .catch((err) => {
    //     toast.error(err?.message);
    // });
  };
  console.log("drag drop edit", edit);
  const handleDragStart = (e, index) => {
    if (!edit) return;
    draggedItemRef.current = index;
    e.dataTransfer.effectAllowed = "move";
  };

  const handleDragOver = (e, index) => {
    e.preventDefault(); // Prevent default to allow drop

    const draggedIndex = draggedItemRef.current;
    if (draggedIndex === null || draggedIndex === index) return;

    setDraggableImages((prevItems) => {
      const newItems = [...prevItems];
      const draggedImage = newItems[draggedIndex];
      newItems.splice(draggedIndex, 1);
      newItems.splice(index, 0, draggedImage);
      draggedItemRef.current = index; // Update reference position
      return newItems;
    });
  };

  const handleDragEnd = () => {
    draggedItemRef.current = null;
  };

  // Handle image selection
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);

    if (files.length + draggableImages?.length > 10) {
      toast.error("You can upload a maximum of 10 images");
      return;
    }

    const newFiles = files.filter((file) => {
      return !draggableImages.some(
        (img) => img.image.name === file.name && img.image.size === file.size,
      );
    });

    const newImages = newFiles.map((file) => ({
      image: file,
      preview: URL.createObjectURL(file),
      isNew: true,
    }));

    setDraggableImages((prev) => [...prev, ...newImages]);
  };
  // console.log(draggableImages, 'newImages')

  // Remove image
  const handleRemoveImage = (index) => {
    let imId = draggableImages[0]?.id;
    console.log(imId, "imId");
    handleImageDelete(imId);
    const newImages = [...draggableImages];
    newImages.splice(index, 1);
    setDraggableImages(newImages);
  };
  // Handle image click for popup
  const handleImageClick = (image) => {
    setSelectedImage(image);
    setPopup(true);
  };

  // // Validate images
  // if (draggableImages.length === 0) {
  //     toast.error('Please upload at least one property image');
  //     return;
  // }

  return (
    <div>
      <div className="d-flex ac-js gap-5 flex-wrap mt-4">
        {draggableImages?.length < 10 && (
          <div className="d-flex ac-js gap-3 flex-wrap">
            <div className="d-flex flex-column as-jc position-relative">
              <img
                src={dummyimage}
                style={{ width: "100px", height: "90px" }}
                alt=""
              />
              {edit && (
                <button
                  className="submit-btn  mt-1 mb-3"
                  onClick={() => imgRef.current?.click()}
                >
                  <CloudUploadRoundedIcon /> Upload
                </button>
              )}
              <input
                type="file"
                className="input-pop mt-2 w-100 d-none"
                accept="image/*"
                onChange={(e) => handleImageChange(e)}
                multiple={true}
                ref={imgRef}
              />
              {errors?.images && draggableImages?.length < 1 && (
                <p className="err">{errors.images}</p>
              )}
            </div>
          </div>
        )}
        {draggableImages?.map((image, index) => (
          <div
            key={index}
            draggable
            onDragStart={(e) => handleDragStart(e, index)}
            onDragOver={(e) => handleDragOver(e, index)}
            onDragEnd={handleDragEnd}
            style={{
              opacity: draggedItem === index ? 0.5 : 1,
              cursor: "move",
              position: "relative",
              backgroundColor: "#F5F5F5",
              padding: "8px 20px 8px 8px",
              borderRadius: "10px",
            }}
          >
            {/* Remove Icon (Shown only in edit mode) */}
            {/* {edit && ( */}
            {edit && (
              <div
                onClick={() => {
                  handleRemoveImage(index);
                  if (image?.id) {
                    setDeletedImages?.((prev) => [...prev, image?.id]);
                  }
                }}
                style={{
                  position: "absolute",
                  top: "0px",
                  right: "12px",
                  borderRadius: "50%",
                  cursor: "pointer",
                  zIndex: 2,
                }}
              >
                <CancelIcon style={{ fontSize: "18px" }} />
              </div>
            )}
            {/* )} */}

            {/* Image */}
            <div onClick={() => handleImageClick(image.image)}>
              <img
                src={
                  image?.image instanceof File
                    ? URL.createObjectURL(image.image)
                    : image?.image
                }
                style={{
                  height: "70px",
                  width: "120px",
                  borderRadius: "5px",
                  cursor: "pointer",
                  objectFit: "contain",
                }}
                alt={`Property image ${index + 1}`}
              />
              {edit && <img src={drag_img} alt="" className="drag-icon" />}
            </div>
          </div>
        ))}
      </div>

      {/* Image Popup */}
      {popup && selectedImage && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div
              className="d-flex ac-je pointer"
              onClick={() => setPopup(false)}
            >
              <CancelIcon />
            </div>
            <div
              style={{
                width: "350px",
                height: "350px",
                overflow: "hidden",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px",
                marginTop: "1rem",
                backgroundColor: "#f8f8f8",
              }}
            >
              <img
                src={
                  selectedImage instanceof File
                    ? URL.createObjectURL(selectedImage)
                    : selectedImage
                }
                alt="Selected"
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain",
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DragAndDrop;
